import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Norwegian route — permanent redirect to the German path
export const Route = createFileRoute("/kort/")({
  beforeLoad: () => {
    throw redirect({ to: "/kreditkarten", statusCode: 301 });
  },
});
